import { render, staticRenderFns } from "./AuthHeaderV2Component.vue?vue&type=template&id=668509a6&"
import script from "./AuthHeaderV2Component.vue?vue&type=script&lang=js&"
export * from "./AuthHeaderV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports